import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import {
  catalogImportPluginExternalRouteRef,
  contributeExternalRouteRef,
  dashboardsRootRouteRef,
  decisionMatrixExternalRouteRef,
  exploreRootRouteRef,
  qetaExternalRouteRef,
  rootRouteRef,
  scaffolderExternalRouteRef,
  supportRootRouteRef,
  taskExplorerRootRouteRef,
  techRadarExternalRouteRef,
  techSpotEventCalendarExternalRouteRef,
} from './routes';
import { taskExplorerPage } from './components/task-explorer';

export const landingPagesPlugin = createFrontendPlugin({
  pluginId: 'landing-pages',
  extensions: [taskExplorerPage],
  routes: {
    root: rootRouteRef,
    dashboards: dashboardsRootRouteRef,
    explore: exploreRootRouteRef,
    support: supportRootRouteRef,
    taskExplorer: taskExplorerRootRouteRef,
  },
  externalRoutes: {
    contribute: contributeExternalRouteRef,
    decisionMatrix: decisionMatrixExternalRouteRef,
    createComponent: scaffolderExternalRouteRef,
    registerComponent: catalogImportPluginExternalRouteRef,
    qeta: qetaExternalRouteRef,
    techRadar: techRadarExternalRouteRef,
    techSpotEventCalendar: techSpotEventCalendarExternalRouteRef,
  },
});
